import React from 'react';
import { Icon } from './Icon';

/** Icon-only button. Ported from D:\campaigning-system\src\components\ui\IconButton.tsx. */
export function IconButton({ icon, label, tone = 'default', size = 'md', className = '', ...rest }) {
  const dim = size === 'sm' ? 'h-8 w-8' : 'h-9 w-9';
  const fontSize = size === 'sm' ? 'text-[17px]' : 'text-[19px]';
  return (
    <button
      aria-label={label}
      title={label}
      className={[
        'grid place-items-center rounded-lg border transition-all duration-200',
        dim,
        tone === 'teal'
          ? 'border-cos-teal/25 bg-cos-teal-faint/60 text-cos-teal-deep hover:bg-cos-teal-faint hover:border-cos-teal/45'
          : 'border-transparent text-cos-ink-muted hover:border-cos-line hover:bg-white/70 hover:text-cos-teal-deep',
        className,
      ].join(' ')}
      {...rest}
    >
      <Icon name={icon} className={fontSize} />
    </button>
  );
}

export default IconButton;
